var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-btn",class:{
		'zelan-btn--primary': _vm.type === 'primary',
		'zelan-btn--danger': _vm.type === 'danger',
		'zelan-btn--loading': _vm.loading,
		'zelan-btn--medium': _vm.size === 'medium',
		'zelan-btn--small': _vm.size === 'small',
		'zelan-btn--mini': _vm.size === 'mini',
		'is-plain': _vm.plain
	},on:{"click":_vm.clickBtn}},[_c('div',{staticClass:"zelan-btn__body"},[_vm._t("default")],2),(_vm.loading)?_c('div',{staticClass:"zelan-btn__loading"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }